/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_RequiredInputs */

const en_validation_required = /** @type {(inputs: Validation_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This field is required.`)
};

const de_validation_required = /** @type {(inputs: Validation_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Feld ist erforderlich.`)
};

/**
* | output |
* | --- |
* | "This field is required." |
*
* @param {Validation_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_required = /** @type {((inputs?: Validation_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_required(inputs)
	return en_validation_required(inputs)
});